export type BusinessUnit = {
  fTreeId: number;
  fTreeName: string;
};

export type BUUnitData = {
  fTreeId: string;
  fTreeUnitId: string;
  fTreeParentUnitId: string;
  fTreeUnitName: string;
  fTreeUnitNumber: string;
  fTreeUnitType: string;
  fTreeManagerId: string;
  fTreeManagerName: string;
  fTreeManagerProfPictureId: string;
  fTreeManagerPosition: string;
  fTreeManagerWorkCity: string;
  fTreeResponsibleHrEmps: number[];
  fTreeEmpHasAccount: boolean;
};

export type OrgTreeData = BusinessUnit & { units: BUUnitData[] };

export enum OrgUnitEmployeeRole {
  DeputyManager = 'DEPUTY_MANAGER',
  HRAdmin = 'HR_ADMIN',
  HRStaff = 'HR_STAFF',
  HRDev = 'HR_DEV',
  HRSalary = 'HR_SALARY',
  HRLimited = 'HR_ADMIN_LIMITED',
  HRAuditor = 'HR_AUDITOR',
  HRPeople = 'HR_PEOP',
  HRPeopleDev = 'HR_PEOP_DEV',
  ITAdmin = 'IT_ADMIN',
  SubstituteAbsenceManager = 'SUBSTITUTE_ABSENCE_MANAGER',
  SubstituteManager = 'SUBSTITUTE_MANAGER',
  AlternateManager = 'ALT_MANAGER',
  Manager = 'MANAGER',
}

export type ResponsibleEmps = {
  fId?: string;
  fEmployeeId: number | null;
  fUnitRole: OrgUnitEmployeeRole;
  fStartDate?: string;
  fEndDate?: string;
};

export type OrganizationUnit = {
  fOrgUnitId: number;
  fOrgUnitName: string;
  fOrgUnitNumber: string;
  fOrgUnitType: string;
  fOrgUnitLoc: number;
  fOrgUnitUrl: string;
  fOrgUnitCreated: string;
  fOrgUnitAvail: string;
  fOrgUnitManager: number;
  fOrgUnitContainingTrees: number[];
  fOrgUnitCostCenters: number[];
  fOrgUnitResponsibleEmps: ResponsibleEmps[];
  fOrgUnitResponsibleHrEmps: number[];
  fOrgUnitPos: number[];
  fOrgUnitIsActive?: boolean;
};
